/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: inline-block;
  -webkit-user-select: none;
          user-select: none;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

::slotted(input[slot=hidden-form-input]) {
  margin: 0 !important;
  opacity: 0 !important;
  outline: none !important;
  padding: 0 !important;
  position: absolute !important;
  inset: 0 !important;
  transform: none !important;
  -webkit-appearance: none !important;
  z-index: -1 !important;
}

:host([scale=s]) {
  --calcite-toggle-spacing: 0.5rem;
  --calcite-internal-input-text-input-padding-inline-end: calc(var(--calcite-toggle-spacing) + 1rem);
}

:host([scale=m]) {
  --calcite-toggle-spacing: 0.75rem;
  --calcite-internal-input-text-input-padding-inline-end: calc(var(--calcite-toggle-spacing) + 1.5rem);
}

:host([scale=l]) {
  --calcite-toggle-spacing: 1rem;
  --calcite-internal-input-text-input-padding-inline-end: calc(var(--calcite-toggle-spacing) + 2rem);
}

.input-wrapper {
  position: relative;
}

.toggle-icon {
  position: absolute;
  display: flex;
  cursor: pointer;
  align-items: center;
  inset-inline-end: 0;
  inset-block: 0;
  padding-inline: var(--calcite-toggle-spacing);
  --calcite-icon-color: var(--calcite-color-text-3);
}

.input-wrapper:hover .toggle-icon,
calcite-input-text:focus + .toggle-icon {
  --calcite-icon-color: var(--calcite-color-text-1);
}

.validation-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}

:host([scale=m]) .validation-container,
:host([scale=l]) .validation-container {
  padding-block-start: 0.5rem;
}

:host([scale=s]) .validation-container {
  padding-block-start: 0.25rem;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}